import VueTypes, { nullable } from 'vue-types';

export const Coordinates = VueTypes.shape({
    lat: VueTypes.string.isRequired,
    lng: VueTypes.string.isRequired
});

export const Schedule = VueTypes.string.isRequired;
export const Phones = VueTypes.string.isRequired;

export const StoreItem = VueTypes.shape({
    id: VueTypes.number.isRequired,
    city: VueTypes.string.isRequired,
    address: VueTypes.string.isRequired,
    schedule: VueTypes.arrayOf(Schedule).isRequired,
    phones: VueTypes.arrayOf(Phones).isRequired,
    coordinates: VueTypes.oneOfType([Coordinates]).isRequired,
    iframe: VueTypes.string.isRequired.def(null),
    pinTitle: VueTypes.oneOfType([String, nullable]).def(null)
}).isRequired;

export const createStoreItem = ({ id, coordinates, city, address, schedule, phones, pinTitle = null, iframe }) => {
    return {
        id: id,
        coordinates: coordinates,
        city: city,
        address: address,
        schedule: schedule,
        phones: phones,
        pinTitle: pinTitle,
        iframe: iframe
    };
};
